import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-tabs-toolbar',
  template: '<ng-content />',
  styleUrls: ['./tabs-toolbar.component.scss']
})
export class TabsToolbarComponent {

}
